var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transaction-insight-popup',{attrs:{"insight-popup-title":_vm.popupTitle,"insight-prefix":'הסכום שיצא',"cashflow-category":_vm.cashflowCategory,"insight":_vm.transaction,"show-feedback-footer":false,"buttons":_vm.buttons,"insight-popup-explanation":_vm.excludeExpenseExplanation},on:{"close":_vm.closeModal}})
}
var staticRenderFns = []

export { render, staticRenderFns }